module.exports = __webpack_public_path__ + "static/img/security2.4e4a05e4.jpeg";